import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmptyPageIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmptyPageIcon = ({ className, ...props }: EmptyPageIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.252 1.25C16.6098 1.25013 16.953 1.39245 17.2061 1.64551L20.3545 4.79395C20.6076 5.04701 20.7499 5.39018 20.75 5.74805V21.4004C20.7498 22.1457 20.1457 22.7498 19.4004 22.75H4.59961C3.85433 22.7498 3.25021 22.1457 3.25 21.4004V2.59961C3.25021 1.85433 3.85434 1.25021 4.59961 1.25H16.252ZM4.75 21.25H19.25V6.75H16.5996C15.8543 6.74979 15.2502 6.14567 15.25 5.40039V2.75H4.75V21.25ZM16.75 5.25H18.6895L16.75 3.31055V5.25Z"
      fill="currentColor"
    />
  </svg>
);

export default EmptyPageIcon;
